const SENTRY_IGNORE_ERROR_PATTERNS = [
  "password is incorrect",
  // Offerings failures are captured as a structured, deduplicated event in
  // `getOfferings` (`reportRevenueCatError`). This generic re-throw from
  // `useSubscriptionOfferings` would otherwise double-report the same failure.
  "subscription offerings are unavailable",
];

export const shouldIgnoreSentryErrorMessage = (message?: string | null): boolean => {
  if (!message) return false;
  const normalized = message.toLowerCase();
  return SENTRY_IGNORE_ERROR_PATTERNS.some((pattern) => normalized.includes(pattern));
};
